jQuery(document).ready(function( $ ) {

  $('.pc-button').parent().addClass('pc-button-wrapper');

});
